module.exports = [
  {
    avatar: "jonMicah",
    quote: "My wife and I didn’t know what to expect before going on the Love Song Couples Getaway and we were so blown away by the experience that we want to go again and again.",
    cite: "Jon Micah of <strong>Kutless</strong>"
  }, {
    avatar: "thomasAndVeronica",
    quote: "We have been married for 14 years. We haven’t missed a single getaway and we will be coming back for year number five.  It makes us feel like newlyweds. It’s a must do!",
    cite: "Thomas & Veronica H. "
  }, {
    avatar: "kieranAndRuth",
    quote: "Thank you so much for all your awesome effort. We haven’t stopped raving about the trip to everyone at our church.  We had so much fun and God blessed us in so many ways.",
    cite: "Kieran & Ruth C."
  }, {
    avatar: "gregLaurie",
    quote: "The Everlasting Tours Staff is very professional and accommodating. It was a pleasure to be a part of the event.  You should definitely by all means do it!",
    cite: "Greg Laurie, <br /><strong>Harvest Ministries</strong>"
  }, {
    avatar: "ernieAndRachell",
    quote: "We are so glad we attended the Love Song Couples Getaway.  It was an amazing trip.  We travel a lot…and hands down this was the best trip on every level!",
    cite: "Ernie & Rachell S."
  }, {
    avatar: "rigoAndLauren",
    quote: "2 years in a row…Best vacation by far!",
    cite: "Rigo & Lauren E."
  }, {
    avatar: "kevinAndMerry",
    quote: "This has been an amazing way to celebrate 24 years of marriage!",
    cite: "Kevin & Merry A."
  }, {
    avatar: "leonAndSue",
    quote: "Had an amazing time – thank you for making this trip so special.  The resort was beautiful, the speakers wonderful, and the music incredible – we were so blessed to be a part of this trip and can’t wait to join you again next year!",
    cite: "Leon & Sue R."
  }
]



// WEBPACK FOOTER //
// ./lib/reviews.js